<mat-card class="content-card">
  <mat-card-header>
    <mat-card-title>
      <h5>Customer Cashbacks</h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div style="width: 100%;">
      <div class="list-item" fxLayout="row" fxLayoutGap="10px" fxFlexFill>
        <span class="secondary" fxFlex> Public Token </span>
        <span class="secondary" fxFlex> Factor </span>
        <span class="secondary" fxFlex> Cashback amount </span>
        <span class="secondary" fxFlex> Paid out on </span>
        <span class="secondary" fxFlex> Txn amount </span>
        <span class="secondary" fxFlex> Txn date </span>
        <span class="secondary" fxFlex="20"> Txn description </span>
      </div>

      <div id="scroll">
        <div *ngFor="let cashback of cashbacks" class="list-item" fxLayout="row" fxLayoutGap="10px" fxFlexFill>
          <span fxFlex>{{ getCardForCashback(cashback)?.token }}</span>
          <span fxFlex>{{ cashback.originalFactor * 100 }}%</span>
          <span fxFlex>{{ getCardInfoForCashback(cashback)?.currency ?? '€' }} {{ cashback.cashbackAmount.formatMoney() }}</span>
          <span fxFlex>
            {{
              cashback.isPaidOut
                ? (cashback.payOutDate | date: "dd.MM.yyyy HH:mm")
                : 'not paid out'
            }}
          </span>
          <span fxFlex>{{ getCardInfoForCashback(cashback)?.currency ?? '€' }} {{ cashback.transactionAmount.formatMoney() }}</span>
          <span fxFlex>{{ cashback.cardActivity.activityDate | date: "dd.MM.yyyy HH:mm" }}</span>
          <span fxFlex="20">{{ replaceBackslashesWithNewlines(cashback.cardActivity.description) }}</span>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
